export default {
  gameDifficulty: {
    easy: 'Easy',
    medium: 'Medium',
    hard: 'Hard',
  },
  editButton: 'Edit',
  imgEditDialog: 'Edit',
  imgUploadDialog: 'Upload',
  downloadModel: 'Download Model & Skeleton',
  uploadCover: 'Upload Cover',
  difficultyV1: {
    warningText1: 'The value has exceeded the maximum',
    warningText2: 'The value has exceeded the maximum',
    warningText3: 'Please enter a valid number',
  },
  difficultyV2: {
    alertText: 'Number format is invalid, please use numbers or strings',
  },
  difficultyV3: {
    alertText: 'Configuration number format is invalid, please contact us',
    alertDesc: {
      config: 'Configuration：',
      error: 'Error details：',
    },
    inputTips: 'Length should not exceed 50 characters',
    inputItem: {
      required: 'Text box cannot be empty',
      placeholder: 'Length should not exceed 50 characters',
    },
    inputNumberTips: 'Only numbers are allowed',
    inputNumberItem: {
      required: 'Text box cannot be empty',
      placeholder: 'Only numbers are allowed',
    },
    checkboxItem: {
      required: 'The option cannot be empty',
    },
    unKnowText: 'Unknown type, please check the configuration',
  },
  difficultySlider: {
    rangeText: 'Adjust the dragging area',
    submit: 'Confirm',
    cancle: 'Cancel',
    title: 'Adjustment',
    form: {
      min: {
        required: 'The value cannot be empty',
        label: 'Minimum',
        warningLable: 'Value',
        warningText1: 'Please enter a valid integer',
        warningText2: 'The value has exceeded the maximum',
        warningText3: 'The value is lower than the minimum allowed',
        warningText4:
          'The minimum value cannot be greater than or equal to the maximum value',
      },
      max: {
        required: 'The value cannot be empty',
        label: 'Maximum',
      },
    },
  },
  previewer: {
    title: 'Refresh',
    loadingText: 'Loading...',
    selectText: 'Please select',
    selectLanguage: 'Preview language',
    selectDevice: 'Preview device',
    selectVersion: 'Preview Variation',
    scenes: {
      start: 'Game Session',
      ending: 'End Session',
    },
    previewSuccess: 'Preview link successfully created',
    qrcodeText: 'View on Mobile',
  },
  saveSuccess: 'Saved Successfully',
  saveFail: 'Save Failed',
  savingWarning: 'Do not perform other actions while saving',
  saveButton: 'Save',
  withoutTemplateId: 'There is no version ID in the URL',
  resourceNotSupport: 'The format is not supported',
  resourceDialog: {
    uploadRuleLabel: 'Supported file type：',
    imageSize: 'Image Size：',
    frameSequence: {
      label: 'Sequence frame format conventions：',
      picName: 'Image naming conventions：',
      imageSize: 'Image size and frames',
    },
    dragonBones: {
      label: 'DragonBones format conventions：',
    },
    video: {
      format: 'Support to upload MP4 (remove the sound in the video)',
    },
    model: {
      label: 'Format:',
      format: 'ZIP format (including glTF/glb/(glb+bin) + jpg/png)',
      rules: 'View Model Upload Specifications',
      rulesTip:
        'Mesh and skeleton scaling must maintain consistent units.<br />Use our template skeleton for skinning and rigging.<br />Bip001 needs to be included in the skinning.',
    },
    resourceEdit: 'Assets Editing',
    submitButton: 'Submit',
    cancleButton: 'Cancel',
    uploadWarning:
      'The same asset is not allowed to be uploaded to the same location',
    uploadingWarning:
      'Pop-up window is not allowed to be closed when uploading assets',
    fileUpload: {
      label: 'Maximum File Size:',
      default: 'Maximum 1MB',
      frameSequence: 'Maximum 8MB',
      dragonBones: 'Maximum 1MB',
      video: 'Maximum 3MB',
      model: 'Maximum 5MB',
    },
    fileMetaData: {
      name: 'Name',
      format: 'Format',
      fileSize: 'File Size',
      size: 'Dimension',
      imageSize: 'Image Size',
      videoSize: 'Video Size',
      duration: 'Music Duration',
    },
    handlerRelated: {
      edit: 'Edit',
      delete: 'Delete',
      update: 'Replace',
      delWarningText1:
        'The basic package resource is not allowed to be deleted',
      delWarningText2: 'The default resource is not allowed to be deleted',
      delWarningText3:
        'Online production resource are not allowed to be deleted',
      delTips: 'Are you sure you want to delete?',
      download: 'Download',
      operation: 'Operations',
    },
  },
  resourceUploader: {
    uploadButton: 'Upload',
    uploadFail: 'Upload Failed, please try again.',
    imgLoadFail: 'Failed to read file',
    warningText1: 'Sequence frame size should not exceed 3MB',
    warningText2: 'DragonBones file size should not exceed 1MB',
    warningText3: 'Audio file size should not exceed 1MB',
    warningText4: 'Image size should not exceed 1MB',
    videoWarningText: 'Video size should not exceed 3MB',
    tagLabelTips:
      'Tags are helpful for refining our algorithm-To develop more accurate and efficient assets variation strategies',
    tagLabel: 'Label',
    editLabel: 'Edit',
    tagPlaceholder: 'Select tag',
    audioLabel: 'Music',
    audioUploadTitle: 'Upload',
    cancel: 'Cancel',
    submit: 'Submit',
    uploadingTips: 'It is not allowed to close popovers when uploading files',
    assetNotExist: 'This asset has been deleted, please select again.',
  },
  languageSelector: {
    error: {
      noDefaultLanguage: 'No Default Language',
    },
  },
  difficultySelect: {
    addText: 'Add',
  },
  editResourceDialog: {
    title: {
      image: 'Images',
      audio: 'Audio',
      dragonBones: 'DragonBones',
      movieClip: 'Sequence',
      model: '3D Model',
    },
  },
  resource: {
    noTagTips:
      "The element hasn't been tagged, please double click and add tag",
    globalNoTagTips: "There are some element hasn't been tagged",
  },
  multiCustom: {
    addBtnTips: 'Add Variation',
    numTips: 'Playable Variations',
    multiCategory: 'Variation Assets',
  },
  qrcodeScan: {
    text: 'Preview',
  },
  editing: 'The Asset is being edited. Please try again later.',
  textEditButton: {
    applyToOtherLanguage: 'Apply to Other Languages',
    applyToOtherLanguageTips: 'Font and Font Size not Included',
    applyToScreen: ['Apply to Horizontal', 'Apply to Vertical'],
    languageAlert: 'Apply to other languages successfully',
    ScreenAlert: [
      'Apply to horizontal successfully ',
      'Apply to vertical successfully',
    ],
  },
  screen: {
    title: 'Screen Adaptation',
    horizontal: 'Landscape',
    vertical: 'Portrait',
    fovOffset: 'Fov Offset',
    orthoHeightOffset: 'Ortho Height Offset',
  },
  scene: {
    title: 'Camera',
    defaultScene: 'Camera{idx}',
    polarAngle: 'Polar Angle',
    azimuthAngle: 'Azimuth Angle',
    radialDistance: 'Radial Distance',
    viewOffsetX: 'View OffsetX',
    viewOffsetY: 'View OffsetY',
    viewOffsetZ: 'View OffsetZ',
    dampingFactor: 'Damping Factor',
  },
  modelEdit: {
    title: 'Model Editing',
    updateBtn: 'Replace Model',
    basic: {
      title: 'Basic Parameters',
      translate: 'Location',
      rotate: 'Rotation',
      scale: 'Scale',
    },
    appearance: {
      title: 'Exterior',
      partsOne: 'Part1',
      partsTwo: 'Part2',
      partsThree: 'Part3',
      partsFour: 'Part4',
      hub: 'Hue',
      saturation: 'Saturation',
      lightness: 'Lightness',
      partsTitle: 'Color modification by component',
      paramTitle: 'Material parameters',
      mainColor: 'Primary color - Overlay',
      occlusion: 'Ambient occlusion',
      roughness: 'Roughness',
      metallic: 'Metallic gloss',
      specularIntensity: 'Specular intensity',
      emissive: 'Emissive color',
    },
    action: {
      title: 'Animation',
      action: 'Animation',
      speed: 'Speed',
      sharedActionTip:
        'Shared by other models, the modifications will affect all of them:',
      keyFrame: 'Keyframe Adjustment',
      keyFrameSlide:
        'Adjust the diamond slider in the preview area on the right side.',
      playSpecialEffects:
        'When the animation reaches this frame, the special effect will play.',
      changeNumber:
        'When the animation reaches this frame, there will be changes in values, such as damage or healing.',
    },
    viewer: {
      editBefore: 'Before',
      editAfter: 'After',
    },
    cancelBtn: 'Cancel',
    saveBtn: 'Save',
    noResult: 'Not adjustable parameters.',
  },
}
